document.addEventListener("DOMContentLoaded", function () {
	const inquirePopups = document.querySelectorAll("#inquire-price-button-popup");

	function prepareInquireForm(popup) {
		popup.querySelectorAll('.globo-formbuilder input[type="text"], .globo-formbuilder input[type="email"], .globo-formbuilder input[type="tel"], .globo-formbuilder textarea').forEach(function (input) {
			const control = input.closest('.globo-form-control');
			if (!control) return;

			control.classList.add('drop-hint-field');
			const label = control.querySelector('label, .globo-label');
			if (!input.placeholder && label) {
				input.placeholder = label.textContent.trim().replace(/\s*(\*|\(required\)|required)\s*$/i, '');
			}
		});
	}

	inquirePopups.forEach(function (popup) {
		prepareInquireForm(popup);
		new MutationObserver(function (mutations) {
			if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) {
				prepareInquireForm(popup);
			}
		}).observe(popup, { childList: true, subtree: true });
	});

	jQuery(".inquire-button").on("click", function (e) {
		e.preventDefault();
		var href = jQuery(this).attr("href");
		if (href.startsWith("#")) {
			const popup = jQuery(href);
			if (popup) {
				popup.addClass("active");
				popup.each(function () { prepareInquireForm(this); });
			}
		}
	});
	jQuery(".drop-hint-popup__close").on("click", function (e) {
		e.preventDefault();
		var popup = jQuery(this).closest(".drop-hint-popup");
		if (popup) {
			popup.removeClass("active");
		}
	});
});
